import modalMixin from '../../mixins/_modal';

// 手数料設定最大数
const MAX_FEE_COMMISSION = 15;

/**
 * 手数料設定の編集モーダル画面
 */
export default {
    name: 'FeeCommissionEditer',
    template: '#fee_commission_editer_template',
    data() {
        return {
            key: '',
            fee: 0,
            rule: 0,
            fees: []
        };
    },
    mixins: [
        modalMixin
    ],
    computed: {
        // 追加できるか
        canAdded: function () {
            return (this.fees.length < MAX_FEE_COMMISSION);
        }
    },
    emits: ['update-fee-commission'],
    methods: {
        show: function (key, fee, rule, fees) {
            this.key = key;
            this.fee = fee;
            this.rule = rule;
            if(fees.length === 0){
                fees = [{'commission': '', 'price': 1}];
            }
            this.fees = fees;
            this.open();
        },
        // 編集を保存する
        save: function (event) {
            // HTML5のバリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();
            this.emitUpdateFeeCommission();
            this.close();
        },

        /**
         * 追加
         */
        add: function () {
            event.preventDefault();
            let price = '';
            if(this.fees.length === 0){
                price = 1;
            }
            this.fees.push({price: price, commission: ''});
        },
        /**
         * 削除
         */
        del: function (index) {
            event.preventDefault();
            this.fees.splice(index, 1);
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集データを通知
        emitUpdateFeeCommission: function () {
            this.$emit('update-fee-commission', this.key, this.fee, this.rule, this.fees);
        }
    }
};